/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-03-21 16:48:01
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\extendsFields\imgcode\index.tsx
 */
import { ProFormFieldProps } from '@ant-design/pro-form/es/components/Field';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styles from './style.module.less';
@inject((store) => store)
@observer
@BindAll()
export class Fields_imgcode extends React.Component<
ProFormFieldProps & {
  type?: string;
  sessionKey?: string;
  onSessionChange?: (value) => void;
  large: boolean;
  // onChange?: (event) => void,
  [key: string]: any;
}
> {
  Unmount = false;
  state = { imgSrc: null, loading: false };
  get Currency() {
    return this.$Store.Currency;
  }
  get formState() {
    return this.props.formState;
  }
  get sessionKey() {
    return this.props.sessionKey || 'imgSession';
  }
  set session(value) {
    this.$ActionTrigger(`formState.${this.sessionKey}`, value);
  }
  set t(value) {
    this.$ActionTrigger(`formState.t`, value);
  }
  get imgSrc() {
    return this.state.imgSrc;
  }
  set imgSrc(imgSrc) {
    this.setState({ imgSrc });
  }
  get loading() {
    return this.state.loading;
  }
  set loading(loading) {
    this.setState({ loading });
  }
  get isLenovoid() {
    return lodash.eq(this.props.type, 'lenovoid')
  }
  async getImgCode() {
    try {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const body = {
        t: React.$Mamba.Encryption.uniqueId().substring(0, 16),
        type: this.isLenovoid ? React.$Mamba.EnumImgCodeType.lenovoid : React.$Mamba.EnumImgCodeType.account
      }
      const res = await this.Currency.getImgCode(body);
      if (this.Unmount) {
        return;
      }
      this.imgSrc = 'data:image/png;base64,' + res.imgCode;
      this.props.onSessionChange && this.props.onSessionChange(res.sessionCode);
      this.session = res.sessionCode;
      this.props.onTChange && this.props.onTChange(body.t);
      this.t = body.t
      // }
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }
  componentDidMount() {
    this.getImgCode();
  }
  componentWillUnmount() {
    this.Unmount = true;
  }
  render() {
    return (
      <div className={styles.imgcode}>
        <React.Antd.ProFormField
          fieldProps={{
            size: this.props.large && 'large',
            prefix: (
              <React.Icons.SafetyCertificateOutlined className={'prefixIcon'} />
            ),
          }}
          placeholder={'请输入图形验证码'}
          rules={[
            {
              required: true,
              message: '请输入图形验证码！',
            },
            // {
            //   pattern: React.$Mamba.Regulars.number_and_letter,
            //   message: '图形验证码格式错误！',
            // },
            // {
            //   max: 4,
            //   message: '图形验证码格式错误！',
            // }
          ]}
          {...(this.props as any)}
        />
        <div className={this.props.large ? styles.largeImg : styles.img}>
          <React.Antd.Image
            preview={false}
            src={this.imgSrc}
            fallback={this.$Static.fallback}
            onClick={this.getImgCode}
          />
        </div>
      </div>
    );
  }
}
